<template>
  <div class="w-full " :class="returnTheme">
    <div class="max-w-lg mx-auto h-dvh pt-8 relative grid grid-rows-[26px_1fr]">
      <img v-if="client == 'nordvaerk'" class="px-6" src="./assets/logo.svg" alt="">
      <img v-if="client == 'bibliotek'" class="px-6" src="./assets/bib.png" alt="">
      <TransitionGroup name="list"  mode="out-in">
        <Location v-if="step == 1" @update:model-value="val => setLatLong(val)" :boxId="boxId" :boxNotFound="boxNotFound" :type="boxType" :boxOnline="boxOnline" :client="client"></Location>
        <Phone v-if="step == 2"  @update:model-value="val => setPhone(val)" :loading="loading"></Phone>
        <Code v-if="step == 3" @update:model-value="val => openDoor(val)" @resendCode="resendCode()" :error="codeError" :loading="loading" :length="challengeLength"></Code>
        <FreeSpace v-if="step == 4" @update:model-value=" val => sendFeedback(val)" :type="boxType" :client="client"></FreeSpace>
        <Confirm v-if="step == 5" @goBack="step = 1" :type="boxType"></Confirm>
      </TransitionGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useFavicon } from '@vueuse/core'
  const icon = useFavicon()
  const config = useRuntimeConfig()
  const route = useRoute()
  const latitude = ref(0);
  const longitude = ref(0);
  const liability_accepted = ref(false);
  const phone = ref('');
  const step = ref(1);
  const challenge = ref(null);
  const fingerprint = ref(null);
  const boxId = ref('');
  const codeError = ref(false);
  const challengeLength = ref(0);
  const loading = ref(false);
  const boxNotFound = ref(false);
  const boxOnline = ref(true);
  const boxType = ref('dangerous_trash');
  const client = ref('nordvaerk');
  const boxValues = ref({
    name: '',
    id: '',
    compartment: '',
  })

  onMounted(() => {
    client.value = window.location.origin.includes('bibliotek') ? 'bibliotek' : 'nordvaerk';
    if (client.value == 'bibliotek'){
      icon.value = 'bib.png';
    } else {
      icon.value = 'favicon.ico';
    }
    boxId.value = route.query.key;
    if (boxId.value) {
      validateKey();
    } else {
      if (route.path !== '/') {
        let keyArray = route.path.split('/')
        boxId.value = keyArray[keyArray.length - 1]
        validateKey();
      }
    }
  })

  useSeoMeta({
    title: () => client.value == 'nordvaerk' ? 'Nordværk' : 'Aalborg Bibliotekerne',
  })

  const returnTheme = computed(() => {
    switch (client.value) {
      case 'nordvaerk':
        return 'text-white bg-primary'
      case 'bibliotek':
        return ' text-bib bg-bib'
      default:
        return 'text-white bg-primary'
    }
  })

  function setLatLong(val: { latitude: number; longitude: number }) {
    latitude.value = val.latitude;
    longitude.value = val.longitude;
    step.value = 2;
    if (val.latitude == 0 && val.longitude == 0) {
      liability_accepted.value = true;
    }
  }
  function validateKey() {
    $fetch(`${config.public.apiBase}/molo/unlock/${boxId.value}`, {
      method: 'get',
      onResponse({ request, response, options }) {
        if (response.ok) {
          boxValues.value.name = response._data.name;
          boxValues.value.id = response._data.id;
          boxValues.value.compartment = response._data.compartment.id;
          boxOnline.value = response._data.online;
          boxType.value = response._data.type;
          return
        } else {
          boxNotFound.value = true;
        }
      },
    })
  }

  function resendCode() {
    sendCode();
  }

  function setPhone(val: { phone: string }) {
    phone.value = val.phone;
    sendCode();
  }

  function sendCode() {
    loading.value = true;
    $fetch(`${config.public.apiBase}/molo/unlock/${boxId.value}`, {
      method: 'post',
      body: {
        phone: phone.value,
        latitude: latitude.value,
        longitude: longitude.value,
        liability_accepted: liability_accepted.value
      },
      onResponse({ request, response, options }) {
        step.value = 3;
        challenge.value = response._data.challenge;
        fingerprint.value = response._data.fingerprint;
        challengeLength.value = response._data.length;
        loading.value = false;
      },
    })
  }

  function openDoor(val: { code: string }) {
    loading.value = true;
    $fetch(`${config.public.apiBase}/molo/unlock/${boxId.value}/challenge/${challenge.value}`, {
      method: 'post',
      body: {
        phone: phone.value,
        latitude: latitude.value,
        longitude: longitude.value,
        liability_accepted: liability_accepted.value,
        otp: val.code
      },
      onResponse({ request, response, options }) {
        if (response._data.errors) {
          codeError.value = true;
          loading.value = false;
        } else {
          if (boxType.value == 'book-out') {
            step.value = 5;
            loading.value = false;
          } else {
            step.value = 4;
            loading.value = false;
          }
        }
      },
    })
  }

  function sendFeedback(val: boolean) {
    step.value = 5;
    $fetch(`${config.public.apiBase}/molo/unlock/${boxId.value}/feedback`, {
      method: 'post',
      body: {
        requires_attention: val
      },
      onResponse({ request, response, options }) {
      },
    })
  }
</script>
